/** @module Classes */ /** typedoc */

import { State } from './State';
import {
    StatePendingEnum,
    StateUploadingAndPreparingEnum,
    TrackTypeEnum
} from '../enums';
import { Permissions } from './Permissions';

/**
 * @class Asset
 * @summary Define the Library Asset used for all Falcor Library Routes
 */
export class LibraryAsset {
    creationDate: string = null;
    creationState: State<StateUploadingAndPreparingEnum> = null;
    duration: number = null;
    fileSize: number = null;
    id: string = null;
    isAlreadyReleased: boolean = null;
    isAtLeastCdAudioQuality: boolean = null;
    hasArtwork = false;
    hasAutomaticMastering = false;
    hasOneMasterFailed: boolean = null;
    hasOneMasterInProgress: boolean = null;
    hasPreview: boolean = null;
    modificationDate: string = null;
    name: string = null;
    originalFormat: string = null;
    ownerId: string = null;
    permissions: Permissions = null;
    // Project is not in core.models yet
    project: any = null;
    read: boolean = null;
    sharesCount = 0;
    soundCloudMasterState: State<StatePendingEnum> = null;
    transferred = null;
    versionsCount: number = null;
    trackType: TrackTypeEnum = null;
    collaboratorsCount: number = null;
    countOfFiles = 1;
}
